import { render, staticRenderFns } from "./ResetRealityButton.vue?vue&type=template&id=6677c28d&scoped=true"
import script from "./ResetRealityButton.vue?vue&type=script&lang=js"
export * from "./ResetRealityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677c28d",
  null
  
)

export default component.exports